module.exports = __webpack_public_path__ + "img/gift2.556f4f96.png";